var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgCatFeaturedActive = function SvgCatFeaturedActive(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#FF9",
    d: "M21.559 11.176c.864-.791.386-2.17-.807-2.331l-4.389-.6a1.46 1.46 0 0 1-1.095-.747l-1.963-3.735c-.533-1.016-2.076-1.016-2.61 0L8.733 7.498a1.45 1.45 0 0 1-1.096.748l-4.389.599c-1.194.163-1.67 1.54-.806 2.33l3.176 2.909c.343.314.499.766.418 1.21l-.75 4.105c-.203 1.117 1.044 1.968 2.112 1.442l3.925-1.938c.424-.21.931-.21 1.355 0l3.926 1.938c1.067.527 2.315-.325 2.111-1.442l-.75-4.106c-.08-.443.076-.895.419-1.21z"
  })));
};
export default SvgCatFeaturedActive;